'use client';
import { useEffect, useState } from 'react';

export const useNotificationPermissionStatus = () => {
  const [permission, setPermission] =
    useState<NotificationPermission>('default');

  useEffect(() => {
    if (typeof window === 'undefined' || !('Notification' in window)) return;

    const handler = () => setPermission(Notification.permission);
    handler();

    let permStatus: PermissionStatus | null = null;
    const canUseNavigatorPermissions =
      typeof navigator !== 'undefined' &&
      !!navigator.permissions &&
      typeof navigator.permissions.query === 'function';

    if (canUseNavigatorPermissions) {
      try {
        const descriptor = { name: 'notifications' as PermissionName };
        navigator.permissions
          .query(descriptor)
          .then((status) => {
            permStatus = status;
            // Some browsers support onchange
            if ('onchange' in status) {
              status.onchange = handler;
            }
          })
          .catch(() => {
            // ignore
          });
      } catch {
        // ignore
      }
    }

    return () => {
      if (permStatus && 'onchange' in permStatus) {
        try {
          permStatus.onchange = null;
        } catch {
          // ignore
        }
      }
    };
  }, []);

  return permission;
};
